import { withSvgIcon } from './withSvgIcon';

export const Eth = withSvgIcon(
  <>
    <path
      d="M11.999 3.37012V9.75033L17.3916 12.16L11.999 3.37012Z"
      fill="#303030"
    />
    <path
      d="M11.9988 3.37012L6.60547 12.16L11.9988 9.75033V3.37012Z"
      fill="#818384"
    />
    <path
      d="M11.999 16.2945V20.6297L17.3952 13.1641L11.999 16.2945Z"
      fill="#303030"
    />
    <path
      d="M11.9988 20.6297V16.2937L6.60547 13.1641L11.9988 20.6297Z"
      fill="#818384"
    />
    <path
      d="M11.999 15.2913L17.3916 12.1602L11.999 9.75195V15.2913Z"
      fill="#131313"
    />
    <path
      d="M6.60547 12.1602L11.9988 15.2913V9.75195L6.60547 12.1602Z"
      fill="#343434"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
